import React from 'react';
import s from "./decay_sim_style.module.css"
import {Images, Text} from "../../AssetReferences";
import {Media} from "./decay_sim_data";
import {PageButton} from "./decay_sim";

export default function MainPage({onDownloadButtonPressed}) {
    return (
        <div id={"MainPage"}>          

            {/*<div className={s.page_header}>MAIN PAGE</div>*/}

            <PageButton onClick={onDownloadButtonPressed} text={"DOWNLOAD"}/>
          
            <p className={s.p_mainPage}>
                decay sim lets users simulate exposure to the internet ecosystem on their files in real time. Al
                bugs take images provided by the user and redraw them, sifting out the information, polymerising
                it with the internet's networked image archive. The condensed output can be saved directly to
                your hard drive.
            </p>

            <div className={s.quick_start}>
                <p className={s.quick_start_h2}>quick start</p>
                <p className={s.quick_start_h3}>download the most recent build and run the file</p>
                <QuickStartOption 
                    index={1}
                    image_src={Media.Quickstart1} 
                    text={"Choose the images to simulate decay. These images will not be stored, uploaded, or seen by anyone but you."}
                    />

                <QuickStartOption
                    index={2}
                    image_src={Media.Quickstart2}
                    text={"When you press start game, each AI will attempt to draw the images you've chosen. Over time, the AI will add new images from the internet, inspired by the in-progress drawings."}
                />

                <QuickStartOption
                    index={3}
                    image_src={Media.Quickstart3}
                    text={"You can add images to your digital compost heap at any time, or save the image the AIs have drawn for you."}
                />
            </div>

            <p className={s.examples_heading}><span className={s.examples_heading_text}>examples</span></p>
            
            <div className={s.examples_box}>
                <ExamplesOption 
                    image_src={Media.Examples1}     
                    text={"A collection of images from my personal computer, my childhood pets are slowly disappear transformed into a sea of dogs, hamsters and goldfish."}
                    time_run={5}
                    />


                <br/>
                
                <ExamplesOption
                    image_src={Media.Examples2}
                    text={"Reference images taken from the organism symbiosis residency. Micro-organisms and digital worlds are conjoined haphazardly with a slew of half-recognised images."}
                    time_run={10}
                    />

                <br/>
                
                <ExamplesOption
                    image_src={Media.Examples3}
                    text={"Final products from the organism symbiosis residency. Our work melts away as new ideas jump from every pixel, every little form wavers and explodes."}
                    time_run={7}
                    />
            </div>
            
            <br/>
            
            <TechnicalCrap/>

        </div>
    )
}



function QuickStartOption({index, image_src, text}) {
    return (
        <div className={s.quick_start_option}>
            <div className={s.quick_start_option_column} style={{width: "2em"}}>
                <div className={s.quick_start_h2}>{index}.</div>
            </div>
            
            <div className={s.quick_start_option_column} 
                 style={{width: "25em",
                 paddingTop: "10px"}}>
                <img 
                    src={image_src} 
                    style={{
                        width: "45%",
                        boxShadow: "10px 5px 5px rgba(0, 0, 0, .05)"
                }}/>
                <p>{text}</p>
            </div>
        </div>
    )
}

function ExamplesOption({image_src, text, time_run})
{
    return (
        <div className={s.examples_option}>
            <div className={s.examples_option_column} 
                 style={{width: "10em",}}>
                <img 
                    className={s.examples_option_image}
                    src={image_src}
                />
            </div>
            
            <div className={s.examples_option_column}
                 style={{width: "25em",
            }}>
                <p>{text}</p>
                <p>time run: {time_run} minutes</p>
                
            </div>
            
        </div>
    )
}

function TechnicalCrap({})
{
    return (
        <div className={s.technical_breakdown_box}>
            <div className={s.technical_breakdown_header}>
                <p style={{margin:0}}><span className={s.technical_break_down_header_text}> technical breakdown</span></p>    
            </div>
            <div className={s.technical_breakdown_text}>
                <p>Decay Sim models the process of digital decomposition. Lynn Margulis' understanding of sex as information transfer, which allows the microscopic world to be read as a bacterial orgy, where information is always on the move. At the macroscopic level, the physical processes of death and decay cannot be understood using this framework, as without the transcriptional elements present in living organisms, information becomes raw material. However, through language and code, humans gain the ability to liberate information from an organism-specific apparatus, to create a strange mirror of the microbial world in the free exchange and recombination of information.</p>
                <p>The internet is a comparatively young technology. As it becomes a host to a range of human, AI, and algorithmic users, the information stored on the internet will be transformed in ways analogous to the protean bacteria. In this networked landscape, decay feels less like bit rot and more like the fusion of information into new forms until it loses its connection to the original – a Ship of Theseus built by tireless algorithms, drifting image scrapers, and the frenzied churning of large language models. Decay Sim aims to give a way to feel this process in your stomach, to dig your things into the soil of the internet and feel the squirming life.</p>
            </div>
        </div>
    )
}